/*
 * Public API Surface of ngx-time-picker
 */

export * from './ngx-time-picker.component';
export * from './ngx-time-picker.module';
